import React from "react";

import PageContainer from '../../components/PageContainer';
import Box from '../../components/Layout/Box';
import { MenuItem } from "@material-ui/core";
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import SectionTitle from '../../components/SectionTitle';
import MissingDataAlert from '../../components/MissingDataAlert/MissingDataAlert';
import TableBuyDealer from "../../components/TableBuyDealer";
import TextInput from "../../components/TextInput";

function BuyDealer({
    classes,
    dispatch,
    inputValue,
    setInputVale,
    nothingFoundNoticeShown,
    status,
    setStatus,
    searchAction
}) {
    return (
        <PageContainer>
            <Box className={classes.rootContainer}>
                <Box className={classes.topContainer} onSubmit={(e) => { e.preventDefault(); }}>
                    <SectionTitle>Compras con distribuidor</SectionTitle>
                    {nothingFoundNoticeShown && <MissingDataAlert status="BAD" text="No se encontraron clientes" />}
                    <Box className={classes.searchContainer}>
                        <InputBase
                            value={inputValue}
                            onChange={(event) => {
                                setInputVale(event.target.value);
                            }}
                            className={classes.input}
                            placeholder="Buscar por nombre de tienda, ID, nombre de cliente…"
                            inputProps={{ 'aria-label': 'search user' }}
                        />
                        <Divider className={classes.divider} orientation="vertical" />
                        <IconButton onClick={() => searchAction()} className={classes.iconButton} aria-label="search">
                            <SearchIcon />
                        </IconButton>
                    </Box>
                </Box>
                <Box className={classes.filterStatus}>
                    <TextInput
                        className={classes.formElement}
                        label="Filtrar por estado"
                        variant="standard"
                        select
                        value={status}
                        onChange={(value) => setStatus(value.target.value)}
                    >
                        <MenuItem value={'PENDING'}>Por verificar</MenuItem>
                        <MenuItem value={'APPROVED'}>Verificación completa</MenuItem>
                        <MenuItem value={'OUTDATED'}>Caducada</MenuItem>
                    </TextInput>
                </Box>
                <Box className={classes.tableContainer}>
                    <TableBuyDealer statusFilter={status}/>
                </Box>
            </Box>
        </PageContainer>
    )
}

export default BuyDealer;